import axios from 'axios';
import apiUrl from '@/constants/api';

export default axios.create({
  baseURL: apiUrl,
});
